module.exports = __webpack_public_path__ + "img/1.08313038.png";